import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { POLICIES, shopFacts } from "@/lib/policies";
import { useTenant } from "./tenantContext";

/** The shop's branding: the tenant's, or (plain /shop, no shop remembered)
 *  the backend's default shop. */
export function useShopBrand() {
  const { brand, slug, ownerId, status } = useTenant();
  const [fallback, setFallback] = useState(null);
  useEffect(() => {
    if (brand || slug || ownerId || status !== "ready") return;
    let gone = false;
    api.get("/store/brand").then(({ data }) => !gone && setFallback(data || {})).catch(() => {});
    return () => { gone = true; };
  }, [brand, slug, ownerId, status]);
  return brand || fallback;
}

/** Storefront footer: the policy links payment gateways look for. */
export default function ShopFooter() {
  const { slug } = useTenant();
  const f = shopFacts(useShopBrand());
  const base = slug ? `/shop/${slug}/policy` : "/shop/policy";
  return (
    <footer className="border-t border-slate-200 bg-slate-50 mt-10" data-testid="shop-footer">
      <div className="max-w-6xl mx-auto px-4 py-6 text-sm">
        <nav className="flex flex-wrap gap-x-5 gap-y-2">
          {POLICIES.map((p) => (
            <Link
              key={p.key}
              to={`${base}/${p.key}`}
              className="text-slate-600 hover:text-slate-900 hover:underline"
              data-testid={`shop-footer-${p.key}`}
            >
              {p.label}
            </Link>
          ))}
        </nav>
        <div className="mt-3 text-xs text-slate-500">
          © {new Date().getFullYear()} {f.legal}
          {f.address ? ` · ${f.address}` : ""}
          {f.phone ? ` · ${f.phone}` : ""}
        </div>
      </div>
    </footer>
  );
}
